// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-copy-icon {\n  background-color: rgba(26, 33, 51, 0.2666666667);\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  text-align: center;\n  margin-top: -6px;\n  margin-right: -8px;\n}", ""]);
// Exports
module.exports = exports;
